module.exports = "<mat-icon svgIcon=\"{{GetIcon()}}\"></mat-icon>\n"